
<template>
  <div>
    <b-card title="Beratungseinwilligung">
      <p>Cable 4 darf mich bzgl. Produkten/Dienstleistungen, zu Werbezwecken und zur Marktforschung kontaktieren. Ich kann meine Einwilligung jederzeit ganz oder teilweise mit Wirkung für die Zukunft widerrufen.</p>

      <validation-observer ref="consultingConsentSectionForm">
        <validation-provider
            #default="{ errors }"
            name="Beratungseinwilligung"
            vid="tv-consulting-consent"
            :rules="{ required: { allowFalse: false } }"
        >
          <b-form-group label="" label-for="tv-consulting-consent" class="required">
            <b-form-radio-group v-model="CHECKOUT_DATA.consulting_consent">
              <b-form-radio value="1">
                Ja, ich möchte informiert bleiben.
              </b-form-radio>
              <b-form-radio value="0">
                Nein.
              </b-form-radio>
            </b-form-radio-group>

            <small class="text-danger" :class="{'has-errors': errors.length > 0}">{{ errors[0] }}</small>
          </b-form-group>
        </validation-provider>
      </validation-observer>
    </b-card>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {
  BCol,
  BFormCheckbox, BFormGroup, BFormInput, BRow,
} from "bootstrap-vue";
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import {required, email, digits} from '@validations'
import {required_if} from 'vee-validate/dist/rules';

export default {
  name: "FTTHSection",
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BRow,
    BCol
  },
  data() {
    return {
      separateAccountOwner: false,
      showInfoBlock: process.env.VUE_APP_ROOT_SHOW_CABLE_4_INFO_BLOCKS
    }
  },
  computed: {
    ...mapGetters(['SERVICE', 'CHECKOUT_DATA']),
  },
  methods: {
    formatPrice(price) {
      return new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'}).format(price / 100)
    },
    validateForm() {
      this.$refs.consultingConsentSectionForm.validate()
    }
  },
  mounted() {
  }
}
</script>

<style scoped>

</style>
